import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import Button from "../../Layout/Button";
import style from "./style.module.css"


const ModalAnimalImage = ({
  idAnimalImage, onUpdate, onCreate, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [image, setImage] = useState(null);
  const [updateImage, setUpdateImage] = useState(null);
  const [animalId, setAnimalId] = React.useState('');

  const [currentImage, setCurrentImage] = useState(null);

  const link = window.location.pathname;
  const animal_id = link.split('/').pop();

  const buildFormData = () =>{
    const formData = new FormData();
    formData.append("animal_id", animalId);

    if(idAnimalImage) {
        formData.append('_method', 'PUT')
        if (updateImage) {
            formData.append("image", updateImage);
        }
    } else{
        if (image){
            formData.append("image", image)
        }
    }
    return formData
  }

  const formData = buildFormData();

  const onSave = () => {
    Swal.fire({
      title: 'Certeza que deseja salvar?',
      text: "Você não conseguirá reverter isso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitData();
      } else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Operação cancelada!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }

  const submitData = () => {
    setSaving(true);
    if (idAnimalImage) {
      BaseApi.post(`/animal_imagem/${idAnimalImage}`, formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Imagem atualiada com sucesso!');
        onUpdate && onUpdate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        }).then(() => window.location.reload(false))
      }).catch(err => {
        console.log(err);
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        setSaving(false);
      })
    }
    else {
      BaseApi.post('/animal_imagem', formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Imagem criada com sucesso');
        onCreate && onCreate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados criados com sucesso!',
          showConfirmButton: false,
          timer: 1500
        }).then(() => window.location.reload(false))
      }).catch(err => {
        console.log(err);
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        
        setSaving(false);
      })
    }
  }

  const handleClose = () => {
    setShowModal(false);
  }

  const handleChangeImage = (e) => {
    const selectedImage = e.target.files[0];
    if (idAnimalImage){
      if (selectedImage)  {
        setUpdateImage(selectedImage);
        setCurrentImage(selectedImage);
      }
    }
    else {
      if (selectedImage)  {
        setImage(selectedImage);
        setCurrentImage(selectedImage);
      }
    }
};

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/animal_imagem${idAnimalImage ? `/${idAnimalImage}` : ''}`).then(res => {
      let data = res.data;
      setImage(data.image)
      setCurrentImage(data.image)
      setAnimalId(animal_id);
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar esta ação ou a imagem não foi encontrada.', 'error');
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
      requestData();
    } else {
      setAnimalId(animal_id);
      setImage(null);
      setUpdateImage(null);
      setLoading(true);
      setSaving(true);
    }
  }, [isShow])

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={idAnimalImage ? "Editar imagem" : "Criar imagem"}>
          <button
            className={`btn btn-${idAnimalImage ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idAnimalImage ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>{idAnimalImage ? "Editar" : "Criar"} imagem</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="image">Imagem </label>

                  <input type="file" accept="image/*"
                  className="form-control"
                  
                  onChange={handleChangeImage} />
                  
                  {idAnimalImage ? (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      <img
                        src={currentImage instanceof File ? URL.createObjectURL(currentImage) : currentImage}
                        alt="imagem"
                        style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                      />
                    </div>
                  ) : 
                    null
                  }

                  {currentImage && !idAnimalImage && (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      {idAnimalImage ? <img src={currentImage} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                        : <img src={URL.createObjectURL(currentImage)} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                      }
                      </div>
                    )
                  }
                </div>


              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
              <Button
                loading={isSaving}
                onClick={onSave}
                className="btn btn-success text-white"
              >
                {idAnimalImage ? "Editar" : "Criar"}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalAnimalImage;